import React from 'react'
import PropTypes from 'prop-types'

import RowPlaceholder from './Placeholder'
import RowNoteActivity from './Block'

const propTypes = {
  style: PropTypes.object.isRequired,
  item: PropTypes.array,
}

export default function ActivityRow({ previousItem, item, ...childProps }) {
  if (!item) {
    return <RowPlaceholder {...childProps} />
  }

  return (
    <RowNoteActivity
      {...childProps}
      noteActivities={item}
      previousNoteActivities={previousItem}
    />
  )
}

ActivityRow.propTypes = propTypes
